// src/components/auth/PasswordReset.jsx
import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";

const PasswordReset = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (event) => {
      if (event === "PASSWORD_RECOVERY") {
        // Instead of a prompt, open the modal
        setShowModal(true);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const handlePasswordUpdate = async () => {
    const newPassword = document.getElementById("new-password-input").value;
    if (newPassword && newPassword.length >= 8) {
      const { error } = await supabase.auth.updateUser({ password: newPassword });
      if (error) {
        alert("Error updating password: " + error.message);
      } else {
        alert("Password updated successfully!");
        setShowModal(false);
      }
    } else {
      alert("Password must be at least 8 characters long.");
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-bold mb-4 text-center">Set Your New Password</h2>
        <input
          id="new-password-input"
          type="password"
          placeholder="New Password"
          className="w-full border border-gray-300 rounded px-3 py-2 mb-4 focus:ring focus:ring-green-400"
        />
        <button
          onClick={handlePasswordUpdate}
          className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700 transition-colors"
        >
          Update Password
        </button>
        <div className="text-center mt-4">
          <button onClick={() => setShowModal(false)} className="text-green-600 hover:underline">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordReset;
